module.exports = __webpack_public_path__ + "static/media/camera-polaroid.dd85ff71.svg";